export const docsHubUrl = "https://docs.deelrxcrm.com";
export const docsHelpdeskUrl = "https://docs.deelrxcrm.com/start/help-and-support";
export const docsChangelogUrl = "https://docs.deelrxcrm.com/CHANGELOG";
export const docsRoadmapUrl = "https://docs.deelrxcrm.com/roadmap";
export const internalRoadmapUrl = "/updates";

export const supportEmail = "support@deelrxcrm.com";
export const supportMailto = "mailto:support@deelrxcrm.com";
export const helpScoutInboxId = "372443";

